
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_1c5es_103",
  "fit-height": "awsui_fit-height_14iqq_1c5es_139",
  "with-side-media": "awsui_with-side-media_14iqq_1c5es_144",
  "variant-default": "awsui_variant-default_14iqq_1c5es_147",
  "variant-stacked": "awsui_variant-stacked_14iqq_1c5es_147",
  "refresh": "awsui_refresh_14iqq_1c5es_155",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_1c5es_205",
  "with-top-media": "awsui_with-top-media_14iqq_1c5es_217",
  "content-wrapper": "awsui_content-wrapper_14iqq_1c5es_222",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_1c5es_227",
  "media": "awsui_media_14iqq_1c5es_232",
  "media-top": "awsui_media-top_14iqq_1c5es_250",
  "media-side": "awsui_media-side_14iqq_1c5es_255",
  "header": "awsui_header_14iqq_1c5es_261",
  "header-with-media": "awsui_header-with-media_14iqq_1c5es_266",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_1c5es_272",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_1c5es_276",
  "header-stuck": "awsui_header-stuck_14iqq_1c5es_282",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_1c5es_292",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_1c5es_295",
  "with-paddings": "awsui_with-paddings_14iqq_1c5es_301",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_1c5es_310",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_1c5es_368",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_14iqq_1c5es_388",
  "dark-header": "awsui_dark-header_14iqq_1c5es_397",
  "content": "awsui_content_14iqq_1c5es_222",
  "content-fit-height": "awsui_content-fit-height_14iqq_1c5es_405",
  "content-with-media": "awsui_content-with-media_14iqq_1c5es_415",
  "footer": "awsui_footer_14iqq_1c5es_419",
  "with-divider": "awsui_with-divider_14iqq_1c5es_423"
};
  